import { Result } from "antd";
import { CustomButton } from "core/interfaces/components/index";
import { ResultStatusType } from "antd/lib/result";
import CustomResultDetail from "components/CustomResultDetail/CustomResultDetail";
import { PagesEnum } from "types/PagesEnum";
import { formStep, personalAreaStep } from "types/StepEnums";
import _ from "lodash";
import moment from "moment";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";

import NavigationManager from "utils/NavigationManager";

import { PaymentMode } from "types/PaymentMode";
import { Enhanced, IReactComponentBase } from "utils/ReactUtils";

const ResultPrenotazione: React.FC<IReactComponentBase> = ({ t, sessionInfo, location, dataForm }) => {
	const result = dataForm.resultPrenotazione;

	const { GoToPage } = NavigationManager(sessionInfo);

	let status: ResultStatusType;
	let title;
	let button;

	let sender = location.state.pageSender;

	if (result?.IsError) {
		status = "error";
		title = t("resultPrenotazione.error.title");
		button = t("resultPrenotazione.error.button");
	} else {
		status = "success";
		switch (sender) {
			case PagesEnum.PersonalArea:
				title = t("resultPrenotazione.success.title.reservationPay");
				button = t("resultPrenotazione.success.button.backToUnsolvedPayments");
				break;
			case PagesEnum.ReservationForm:
			default:
				title = t("resultPrenotazione.success.title.reservationComplete");
				button = t("resultPrenotazione.success.button.newReservation");
				break;
		}

		if (!result?.ResPrenotazione?.MailInviata) {
			status = "warning";
			title = t("resultPrenotazione.warningMail.title");
		}

		if (window.CONFIG.REACT_APP_PAYMENT.ENABLED && !result?.PaymentSuccess) {
			status = "warning";
			title = t("resultPrenotazione.warning.title");
		}
	}

	const returnToHomePage = () => {
		switch (sender) {
			case PagesEnum.PersonalArea:
				GoToPage(PagesEnum.PersonalArea, personalAreaStep.sospesi);
				break;

			case PagesEnum.ReservationForm:
			default:
				GoToPage(PagesEnum.ReservationForm, formStep.Home, { reset: true });
				break;
		}
	};

	return (
		<Result
			status={status}
			title={
				<>
					{title}
					<br />
					{result?.ResPrenotazione?.CodPai ? `Ordine n°${result?.ResPrenotazione?.CodPai}` : ""}
				</>
			}
			extra={[
				<CustomResultDetail
					key={result?.ResPrenotazione?.CodPai}
					IsError={result?.IsError}
					NomePrestazione={_.join(
						_.flatMap(result?.PreventivoDetail, (value) => {
							return value.Attivita;
						}),
						",<br> "
					)}
					DatePrenotazione={_.join(
						_.flatMap(result?.PreventivoDetail, (value) => {
							return t("resultPrenotazione.dataOraPrenotazioneFormat").format(
								moment(value.Da!).toDate().toTextWeekday(true),
								moment(value.Da).format("L"),
								moment(value.Da).format("LT"),
								moment(value.A).format("LT")
							);
						}),
						"<br>"
					)}
					NomeOperatore={_.join(
						_.flatMap(
							result?.PreventivoDetail?.filter((operatore: any) => {
								return !operatore.OperatoreGenerico;
							}),
							(value) => {
								return value.DsOperatore;
							}
						),
						",<br>"
					)}
					EsitoPagamento={result?.PaymentSuccess}
					IdTransazione={result?.IdTransazione}
					ResPrenotazione={result?.ResPrenotazione}
					SaltatoPagamento={result?.PaymentMode === PaymentMode.SaltaPagamento}
				/>,
				<CustomButton key={-2} text={button} style={{ marginTop: "5%" }} OnClick={returnToHomePage} buttonType={CustomButtonType.positive} />,
			]}
		/>
	);
};

export default Enhanced(ResultPrenotazione, { componentNamespace: "ResultPrenotazione" });
